<template>
    <div>
      <img  src="../../../assets/images/banner-500/invitedetail.jpg">
    </div>
</template>

<script>
  export default {
      name: "joinpartbanner"
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/joincontentcoms/joinpartbanner.vue